import { AxiosInstance } from "axios";
import { RequestCoords } from "../DangerZones/DangerZones.type";


export default class RemoteGoogleLink {
    private axios: AxiosInstance;

    constructor(axios: AxiosInstance) {
        this.axios = axios;
    }


    //POST CREATE GOOGLE MEET LINK WITH COORDINATES
    public async postPacientCoordinates(absenteeAppointmentId: string, coordinates: RequestCoords): Promise<void> {
        const url: string = `/absentee-appointments/video-call/accept/${absenteeAppointmentId}`
        return this.axios.post(url, coordinates)
    }

}

